import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ListSubheader from '@mui/material/ListSubheader';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import inlineStyles from './accountGroupStyles';

const PciTelecomDetails = (props) => {
	const { values, handlePciTelecomCaptureConfigIdChange, errors } = props;

	return (
		<div>
			<ListSubheader style={inlineStyles.subHeader}>
				<FormattedMessage {...messages.lbPciTelecomDetails} />
			</ListSubheader>

			<TextField
				id="pciTelecomCaptureConfigId"
				label={<FormattedMessage {...messages.lbPciTelecomCaptureConfigId} />}
				fullWidth
				value={values.pciTelecomCaptureConfigId}
				onChange={handlePciTelecomCaptureConfigIdChange}
				error={!!errors.srtPciTelecomCaptureConfigId}
				helperText={errors.srtPciTelecomCaptureConfigId}
				variant="standard"
			/>
		</div>
	);
};

PciTelecomDetails.propTypes = {
	values: PropTypes.shape({
		pciTelecomCaptureConfigId: PropTypes.string,
	}).isRequired,
	handlePciTelecomCaptureConfigIdChange: PropTypes.func.isRequired,
	errors: PropTypes.shape({
		srtPciTelecomCaptureConfigId: PropTypes.string,
	}).isRequired,
};

export default PciTelecomDetails;
